module.exports = __webpack_public_path__ + "static/media/avatar.be41cdb0.jpeg";